import { Table } from "antd";
import type { ColumnsType, TableProps } from "antd/es/table";
import { useTranslation } from "react-i18next";
import type { PaginatedQueryResult } from "@/shared/hooks/usePaginatedQuery";

interface DataTableProps<T> {
	columns: ColumnsType<T>;
	query: PaginatedQueryResult<T>;
	rowKey?: keyof T & string;
	/**
	 * Qator atributlari — «ro'yxat → profil» burg'ulashi uchun.
	 *
	 * ⚠️ Qator bosilishi bilan ustundagi HAVOLA to'qnashadi: havolaning
	 * o'z `onClick` ida `stopPropagation()` chaqirilishi SHART, aks holda
	 * foydalanuvchi bo'limni bosib xodim profiliga tushardi.
	 */
	onRow?: TableProps<T>["onRow"];
}

/**
 * Antd `Table` ustida server-side pagination.
 *
 * Sahifalash holati `usePaginatedQuery` ichida yashaydi, jadvalda emas — shu
 * sababli filtrlarni o'zgartirganda sahifani qayta o'rnatish bir joyda hal bo'ladi.
 */
export function DataTable<T extends object>({
	columns,
	query,
	rowKey = "id" as keyof T & string,
	onRow,
}: DataTableProps<T>) {
	// ⚠️ `shared.json` dagi `dataTable.showTotal` dan — avval o'zbekcha
	// "… / N ta" QATTIQ YOZILGAN edi, til `ru` bo'lsa ham o'zgarmasdi.
	const { t } = useTranslation("shared");

	return (
		<Table<T>
			columns={columns}
			dataSource={query.items}
			rowKey={rowKey}
			onRow={onRow}
			loading={query.isLoading || query.isFetching}
			scroll={{ x: "max-content" }}
			pagination={{
				current: query.meta.page,
				pageSize: query.meta.limit,
				total: query.meta.total,
				showSizeChanger: true,
				pageSizeOptions: [10, 20, 50, 100],
				showTotal: (total, range) =>
					t("dataTable.showTotal", { from: range[0], to: range[1], total }),
				onChange: (page, pageSize) => {
					query.setPage(page);
					if (pageSize !== query.limit) {
						query.setLimit(pageSize);
					}
				},
			}}
		/>
	);
}
